import { render } from "./TradeTypeahead.vue?vue&type=template&id=67505eff&scoped=true"
import script from "./TradeTypeahead.vue?vue&type=script&lang=js"
export * from "./TradeTypeahead.vue?vue&type=script&lang=js"

import "./TradeTypeahead.vue?vue&type=style&index=0&id=67505eff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67505eff"]])

export default __exports__